// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingSpinner_wrapper__XQCbH","container":"LoadingSpinner_container__F0FLi","spinnerUpgrade":"LoadingSpinner_spinnerUpgrade__MXuF4"};